/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompaniesNearMeFiltersResponse } from '../../models/get-companies-near-me-filters-response';
import { GetCompaniesNearMeRequest } from '../../models/get-companies-near-me-request';

export interface GetCompaniesNearMeFilters$Params {
      body: GetCompaniesNearMeRequest
}

export function getCompaniesNearMeFilters(http: HttpClient, rootUrl: string, params: GetCompaniesNearMeFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompaniesNearMeFiltersResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompaniesNearMeFilters.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompaniesNearMeFiltersResponse>;
    })
  );
}

getCompaniesNearMeFilters.PATH = '/api/companies-near-me-filters';
